import Swiper from 'swiper/bundle';

export default function blockImageSlider() {
  document.querySelectorAll('.image-slider:not(.image-slider--disabled)').forEach(function (slider) {
if(!slider) return;
    const swiper = new Swiper(slider, {
      speed: 1000,
      loop: true,
      autoplay: {
        delay: 5000,
        disableOnInteraction: false,
      },
      navigation: {
        nextEl: slider.querySelector('.image-slider__arrow--next'),
        prevEl: slider.querySelector('.image-slider__arrow--prev'),
      },
       // włączenie efektu parallax  tylko na desktopie
      parallax: window.innerWidth > 992,
      slidesPerView: 1,

    });
  });
}
